import { WidgetRegistryEntry } from "@smallstack/widget-core";

export const PasswordLoginWidget: WidgetRegistryEntry = {
  name: "PasswordLogin",
  configuration: () => import("./configuration").then((m) => m.PasswordLoginWidgetConfiguration),
  component: () => import("./password-login-widget.component").then((m) => m.PasswordLoginWidgetComponent)
};
